

function History() {

    return (
        <div>
            <h1 className="page-title">Historik</h1>

            <p className="lead">Kanallöpet längs Göta Kanal mellan Borensberg och Ljungsbro
                startade år 1981. Det var ett samarrangemang mellan Borensbergs IF, skid- och friidrottssektionen,
                Ljungsbro Friidrottsklubb och Vreta Skid- och motionsklubb. (BIF, LjFK och Vreta SoMK.)</p>

            <p>Tävlingen bestod av tävlings- och motionsklass, halvmarathon (21095 m) med start i Borensberg,
                10 km motionsklass med start vid Sjöbacka bro och 6.5 km motion med start vid Ljungs Västra
                bro.</p>

            <p>Efter en blygsam inledning med ca. 260 deltagare växte arrangemanget till en topp år 1991 med
                ca. 1.600 löpare. Populärast var att springa 10 km, och vid startfältet i Sjöbacka
                trängdes ca. 800 löpare i alla åldrar.</p>

            <p>åren därefter dalade intresset vad gäller antalet anmälda till ca. 500. år
                1998 efter 18 år, lades kanallöpet i "malpåse" av flera olika skäl.</p>

            <p>år 2003 när Göta Kanal AB stöttar arrangemanget bl.a. genom att det skall
                ingå i Göta kanalklassikern, har föreningarna beslutat att återuppta
                kanallöpet. Det skall gå av stapeln söndagen den 18 maj, dock endast med motionsklasser,
                10 km och 5 km. Starten blir Sjöbacka bro, resp. Kungs Norrby med mål i Borensberg.
                Arrangerande föreningar är: Borensbergs IF, Ljungsbro Friidrott, Vreta SoMK samt Göta
                Kanal AB.</p>

            <p>år 2004 vände vi på det hela med mål i Ljungsbro. år 2005 arrangerades
                Kanallöpet som DM-tävling på &frac12;-mara (21 km) samt &frac12;-mara motion , 10 km och
                5 km motion. år 2006 arrangerades samtliga 5 klasser och så har det varit till 2009
                då även "Stavgång 5 km" infördes.</p>

            <p>år 2009 lämnade Ljungsbro Friidrott arrangemanget och 2013 ingick OK Skogsströvarna som
                medarrangör.</p>

            <p>år 2013 arrangeras loppet av Borensbergs IF, OK Skogsströvarna och Vreta SoMK. Antalet
                deltagare detta år var med 700 löpare i mål.</p>

            <p>år 2014 arrangeras loppet den 4:e maj av Borensbergs IF, OK Skogsströvarna och Vreta SoMK.
                Antalet deltagare detta år var med 720 löpare i mål, fördelade på 21 km M
                med 56 löpare, 21 km K med 25 löpare, 21 K motion med 262 löpare, 10 km Motion med 240
                löpare, 5 km Motion med 141 löpare och 5 km Stavgång med 6 deltagare i mål.</p>

            <p>år 2015 arrangeras loppet den 10:e maj av Borensbergs IF, OK Skogsströvarna och Vreta SoMK.
                Antalet deltagare detta år var 546 löpare i mål, fördelade på 21 km M med 46
                löpare, 21 km K 23 löpare, 21 km motion 206 löpare, 10 km Motion med 159 löpare, 5
                km Motion med 102 löpare och 5 km Stavgång med 10 löpare i mål.</p>

            <p>år 2016 arrangeras loppet den 8:e maj av Borensbergs IF, OK Skogsströvarna och Vreta SoMK.
                Antalet deltagare detta år var 441 löpare i mål, fördelade på 21 km M med 35
                löpare, 21 km K 11 löpare, 21 km motion 154 löpare, 10 km Motion med 127 löpare, 5
                km Motion med 110 löpare och 5 km Stavgång med 4 löpare i mål.<br/>
                Som synes tyvärr en nedgång i antalet deltagare -varför?</p>

            <p>år 2017 arrangeras loppet den 7:e maj av Borensbergs IF, OK Skogsströvarna och Vreta SoMK.
                Antalet deltagare detta år var 513 löpare i mål, fördelade på 21 km M med 43
                löpare, 21 km K 11 löpare, 21 km motion 188 löpare, 10 km Motion med 165 löpare, 5
                km Motion med 102 löpare och 5 km Stavgång med 4 löpare i mål.<br/>
                Som synes en glädjande uppgång av antalet deltagare!</p>

            <p>år 2018 arrangeras loppet den 6:e maj av Borensbergs IF, OK Skogsströvarna och Vreta SoMK.
                Antalet deltagare detta år var 452 löpare i mål, fördelade på 21 km M med 37
                löpare, 21 km K 13 löpare, 21 km motion 181 löpare, 10 km Motion med 115 löpare, 5
                km Motion med 103 löpare och 5 km Stavgång med 3 löpare i mål.<br/>
                Som synes ett något minskat antal deltagare jämfört med förra året.</p>

            <p>år 2019 arrangeras loppet den 5:e maj av Borensbergs IF, OK Skogsströvarna och Vreta SoMK.
                Antalet deltagare detta år var 313 löpare i mål, fördelade på 21 km M med 25
                löpare, 21 km K 6 löpare, 21 km motion 131 löpare, 10 km Motion med 64 löpare, 5 km
                Motion med 82 löpare och 5 km Stavgång med5 löpare i mål.<br/>
                Som synes en katastrofal minskning av antal deltagare jämfört med förra året.</p>

        </div>
    );
}

export default History;